export default __webpack_public_path__ + "static/media/sidebar-logo.ac6b4b3e.png";